var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-sm btn-warning",on:{"click":_vm.disablePassword}},[_c('i',{staticClass:"fas fa-times"}),_vm._v(" "+_vm._s(_vm.$t('account.security.password.disable'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }